import * as Yup from 'yup';

// REGISTRAION VALIDATION SCHEMA
export const RegistrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters')
    .required('First name is required'),
  lastname: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters')
    .required('Last name is required'),
  username: Yup.string()
    .required('Email address is required')
    .email('Invalid email address')
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters'),
  password: Yup.string().required('Password is required'),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password'), ''], 'Passwords must match')
});

export const ConfirmRegistrationSchema = Yup.object().shape({
  confirmationCode: Yup.string().required('Confirmation code is required')
});
